<template>
  <div>
    <div v-if="group === 'EH'">
      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_3">
        <strong>1. Copy of father’s IC (Singaporean / Permanent Resident) or FIN card (copied on both sides).</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_4">
        <strong>2. Copy of father’s passport showing the page of father’s personal particulars</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_5">
        <strong>3. Copy of mother’s IC (Singaporean/ Permanent Resident) or FIN card (copied on both sides).</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_6">
        <strong>4. Copy of mother’s passport showing the page of mother’s personal particulars</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_7">
        <strong
          >5. Copy of child’s birth certificate (Singaporean only), Re‐Entry Permit (Permanent Resident only), FIN card or Student Pass (copied on both
          sides)</strong
        >
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_8">
        <strong>6. Copy of child’s passport showing the page of child’s personal particulars</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_9">
        <strong>7. Photo of the child (for student’s ID and application form)</strong><br />
        <span>photo must be clear, front-facing and taken against white background</span>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_10">
        <strong>8. Photo for each parent/guardian for family photo ID</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_11">
        <template v-if="selectOptSchool === schools.Orchard">
          <strong>9. Student's Previous 2 Years of School Reports</strong>
          <div>- Last year level full year school report</div>
          <div>- Current year level full year school report (or all reports you have received for current year)</div>
        </template>
        <strong v-else>9. Copy of child’s latest school report (in English)</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_12">
        <strong
          >10. Copy of child's immunisation record (Immunisation against Diphtheria and Measles is compulsory in Singapore. Immunisation records is required for
          students under 12 years old.)</strong
        >
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_15">
        <strong>11. Any other relevant medical, psychoeducation, developmental or special education evaluation reports (if applicable)</strong>
      </ApfUploadInput>

      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasPaymentDoc" style="margin-bottom: 10px">
        <el-alert title="Payment proof document is required" type="error"></el-alert>
      </div>
      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_payment">
        <strong
          >*12. Screenshot or proof of payment for the application fee of S$654, inclusive of 9% GST. (Kindly note that payment must be made before the school
          processes the application)</strong
        >
        <ApfUploadPaymentInfo group="EH" :school="selectOptSchool" />
      </ApfUploadInput>
    </div>
    <div v-else-if="group === 'CLAY'">
      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_3">
        <strong>1. Copy of child's vaccination record <strong class="text-danger">*</strong></strong>
      </ApfUploadInput>
      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasChildVaccination" style="margin-bottom: 10px">
        <el-alert title="Copy of child's vaccination record is required" type="error"></el-alert>
      </div>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_4">
        <strong>2. Passport-sized photograph of your child <strong class="text-danger">*</strong></strong>
      </ApfUploadInput>
      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasChildPassport" style="margin-bottom: 10px">
        <el-alert title="Passport-sized photograph of your child is required" type="error"></el-alert>
      </div>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_5">
        <strong>3. Copy of child's Dependant Pass/ Student Pass (if applicable)</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_6">
        <strong>4. Any other relevant medical reports (if applicable) </strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_payment">
        <strong>5. Screenshot or proof of payment of the registration fee. <strong class="text-danger">*</strong></strong>
        <ApfUploadPaymentInfo group="CLAY" />
      </ApfUploadInput>

      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasPaymentDoc" style="margin-bottom: 10px">
        <el-alert title="Payment proof document is required" type="error"></el-alert>
      </div>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_9">
        <strong>6. Completed <a class="text-primary" @click="viewDoc">Enrolment Terms and Conditions</a> <strong class="text-danger">*</strong></strong>
      </ApfUploadInput>
      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasTC" style="margin-bottom: 10px">
        <el-alert title="Enrolment Terms and Conditions is required" type="error"></el-alert>
      </div>
    </div>

    <div v-else-if="group === 'PRE'">
      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_3">
        <strong>1. Copy of child's vaccination record <strong class="text-danger">*</strong></strong>
      </ApfUploadInput>
      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasChildVaccination" style="margin-bottom: 10px">
        <el-alert title="Copy of child's vaccination record is required" type="error"></el-alert>
      </div>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_4">
        <strong>2. Passport-sized photograph of your child <strong class="text-danger">*</strong></strong>
      </ApfUploadInput>
      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasChildPassport" style="margin-bottom: 10px">
        <el-alert title="Passport-sized photograph of your child is required" type="error"></el-alert>
      </div>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_5">
        <strong>3. Copy of child's Dependant Pass/ Student Pass (if applicable)</strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_6">
        <strong>4. Any other relevant medical reports (if applicable) </strong>
      </ApfUploadInput>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_payment">
        <strong>5. Screenshot or proof of payment of the registration fee and deposit <strong class="text-danger">*</strong></strong>
        <ApfUploadPaymentInfo group="PRE" :preSchoolInfo="preSchoolInfo" :school="selectOptSchool" />
      </ApfUploadInput>
      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasPaymentDoc" style="margin-bottom: 10px">
        <el-alert title="Payment proof document is required" type="error"></el-alert>
      </div>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_9">
        <strong>6. Completed <a class="text-primary" @click="viewDoc">Enrolment Terms and Conditions</a> <strong class="text-danger">*</strong></strong>
      </ApfUploadInput>
      <div class="requiredFieldsMsg" v-if="validator.apat_ids.$error && !validator.apat_ids.hasTC" style="margin-bottom: 10px">
        <el-alert title="Enrolment Terms and Conditions is required" type="error"></el-alert>
      </div>

      <ApfUploadInput :attachments="arrChecklistAttach" @remove="handleRemove" @add="handleAdd" doc="doc_10">
        <strong
          >7. Completed <a class="text-primary" href="https://kws.etonhouse.com/images/PRE_Waitlist_Form.pdf" target="_blank"> Waitlist Form</a> (Only
          applicable for parents who have been on the waitlist)</strong
        >
      </ApfUploadInput>
    </div>
  </div>
</template>
<script>
import ApfUploadInput from '@/pages/application/components/ApfUploadInput'
import { schools } from '@/pages/application/data'
import ApfUploadPaymentInfo from '@/pages/application/texts/ApfUploadPaymentInfo'
export default {
  name: 'ApfDocumentChecklist',
  props: ['arrChecklistAttach', 'selectOptSchool', 'group', 'validator', 'preSchoolInfo', 'customDoc'],
  components: { ApfUploadPaymentInfo, ApfUploadInput },
  data() {
    return {
      schools: schools,
    }
  },
  mounted() {
    console.log(this.group)
  },
  methods: {
    handleAdd(event, attType) {
      this.$emit('onFileChanged', event, attType)
    },
    handleRemove(fItem, attType) {
      this.$emit('removeChecklistAttach', fItem, attType)
      this.validator.apat_ids.$touch()
    },
    viewDoc() {
      window.open(this.preSchoolInfo?.termInfo || this.customDoc, '_blank')
    },
  },
}
</script>
